import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import MUIDataTable from 'mui-datatables';

import PatientSearchFilters from './PatientAuditSearchFilters';
import LoadingPageText from '../../../components/common/Loading/LoadingPageText';
import AuditDetails from './AuditDetails';
import AuditHistory from './AuditHistory';

import { useFetchPatientAuditSearch } from '../../../actions/entities/patients/fetchHooks';
import { tableSettings } from './patientAuditSearchTableSettings';
import { eventHandlers } from './patientAuditSearchHandler';
import { PATIENT_GET_FAILURE } from '../../../actions/constants/types';

import globals from '../../../globals/communityGlobals';
import { getDateForApi } from '../../../utils/dates';

export default function PatientAuditSearchPage() {
  document.title = 'Patient Audit';

  const dispatch = useDispatch();
  const [state, setState] = useState({
    forceReload: false,
    from: new Date(globals.now.subtract(3, 'months').format(globals.dateFormats.date)),
    to: new Date(globals.now.format(globals.dateFormats.date)),
    forename: '',
    surname: '',
    nhsNumber: '',
    currentPage: 1,
    pageSize: 15,
    sortColumn: '',
    sortDirection: '',
    auditType: 0,
    unsuccessfullyPatientRequest: null,
    patientAuditHistory: null,
  });
  const getModel = {
    forceReload: state.forceReload,
    from: state.from ? getDateForApi(state.from) : null,
    to: state.to ? getDateForApi(state.to) : null,
    forename: state.forename,
    surname: state.surname,
    nhsNumber: state.nhsNumber,
    currentPage: state.currentPage,
    pageSize: state.pageSize,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
    auditType: state.auditType,
  };
  const { data, isDataLoading, auth, error, isTableDataLoading } = useFetchPatientAuditSearch(getModel);
  const events = eventHandlers(state, setState, auth);

  if (isDataLoading)
    return <LoadingPageText showHeader={false}>Wait a moment while we gather patients info...</LoadingPageText>;

  if (error && error.message) dispatch({ type: PATIENT_GET_FAILURE, message: error.message });

  const settings = tableSettings({
    count: data.totalCount,
    page: data.currentPage - 1,
    pageSize: data.pageSize,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
    eventHandlers: events,
    isTableDataLoading,
    auditType: state.auditType,
  });

  return (
    <React.Fragment>
      <PatientSearchFilters onSubmit={events.onFiltersChange} errorProps={error ? error.props : []} />
      <div className="page-content-wrapper">
        <MUIDataTable title={settings.name} data={data.items} columns={settings.columns} options={settings.options} />
      </div>
      {state.unsuccessfullyPatientRequest !== null && (
        <AuditDetails
          modelDetails={state.unsuccessfullyPatientRequest}
          auth={auth}
          onClose={events.onCloseDetailPanel}
        />
      )}
      {state.patientAuditHistory !== null && (
        <AuditHistory modelDetails={state.patientAuditHistory} auth={auth} onClose={events.onCloseDetailPanel} />
      )}
    </React.Fragment>
  );
}
